import { render, staticRenderFns } from "./IssueCertificate.vue?vue&type=template&id=167ea169"
import script from "./IssueCertificate.vue?vue&type=script&lang=js"
export * from "./IssueCertificate.vue?vue&type=script&lang=js"
import style0 from "./IssueCertificate.vue?vue&type=style&index=0&id=167ea169&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports